import { DeleteIcon, Search2Icon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Td,
  Tooltip,
  Tr,
  IconButton,
} from "@chakra-ui/react";
import CustomInput from "components/common/customInput/CustomInput";
import { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";

import { foreignDesignations, isActiveUser, roles } from "./utils/constant";

const UserApprovalForeign = ({
  index,
  values,
  setFieldValue,
  isDisabled,
  setDeletedApproavals,
  remove,
  data,
  isLoading,
  selectModes,
  debouncedLoadOptions,
  regionPath,
  regionValue,
  generateLevels,
  type
}: any) => {
  const [selectMode, setSelectMode] = useState(selectModes || "select-async");

  const basePath = regionPath ? `${regionPath}[${index}]` : `approvals[${index}]`;
  const approvals = regionPath ? (values.regionApprovals?.[regionValue]?.approvals || []) : (values.approvals || []);

  // Auto-define Level and Role based on designation/index IF NOT ALREADY SET
  useEffect(() => {
    // Only set defaults if missing
    if (!approvals[index]?.role) {
      setFieldValue(`${basePath}.role`, roles[1]); // Default to Approver
    }

    if (!approvals[index]?.level) {
      const mapping: any = {
        "Initiator": 1,
        "FI user": 2,
        "GST user": 3,
        "TDS user": 4,
        "Approver 1": 5,
        "Approver 2": 6,
        "Approver 3": 7,
      };

      const currentDesignation = approvals[index]?.designation;
      const levelNum = mapping[currentDesignation] || (index + 1);
      setFieldValue(`${basePath}.level`, {
        label: `Level-${levelNum}`,
        value: `level-${levelNum}`
      });
    }
    
    // Set default designation if missing
    if (!approvals[index]?.designation && index < foreignDesignations.length) {
      setFieldValue(`${basePath}.designation`, foreignDesignations[index]);
    }
  }, [index, setFieldValue, basePath]);

  const loadOptions = (
    inputValue: string,
    callback: (options: any[]) => void
  ) => {
    debouncedLoadOptions(inputValue, callback);
  };

  return (
    <Tr key={index} overflow="auto">
      <Td w="33%">
        <Flex columnGap={2}>
          {selectMode === "select-async" ? (
            <CustomInput
              type="select-async"
              name={`${basePath}.username`}
              value={approvals[index]?.username || ""}
              onChange={(e: any) => {
                setFieldValue(`${basePath}.username`, e);
                setFieldValue(`${basePath}.user`, e?.id || e?._id || "");
              }}
              isClear={true}
              getOptionLabel={(option: any) => option.email}
              getOptionValue={(option: any) => option.id}
              loadOptions={loadOptions}
              options={data}
              loading={isLoading}
              placeholder="Search..."
              disabled={isDisabled}
              rest={{ minWidth: "120px", width: "100%" }}
              isBoxSelect={true}
            />
          ) : (
            <CustomInput
              type="text"
              name={`${basePath}.username`}
              value={approvals[index]?.username || ""}
              onChange={(e: any) => {
                setFieldValue(`${basePath}.username`, e.target.value);
              }}
              placeholder="Use email id"
              disabled={isDisabled}
              rest={{
                width: "100%",
              }}
            />
          )}
        </Flex>
      </Td>

      <Td w="33%">
        <CustomInput
          placeholder="Select Designation"
          type="select"
          name={`${basePath}.designation`}
          value={approvals[index]?.designation || ""}
          options={foreignDesignations}
          onChange={(e: any) => {
            setFieldValue(`${basePath}.designation`, e);

            // Map designation to level automatically
            const designationValue = e.value || e;
            const mapping: any = {
              "Initiator": 1,
              "FI user": 2,
              "GST user": 3,
              "TDS user": 4,
              "Approver 1": 5,
              "Approver 2": 6,
              "Approver 3": 7
            };

            const levelNum = mapping[designationValue];
            if (levelNum) {
              setFieldValue(`${basePath}.level`, {
                label: `Level-${levelNum}`,
                value: `level-${levelNum}`
              });
            }
          }}
          rest={{
            width: "100%",
          }}
          disabled={isDisabled}
          isBoxSelect={true}
        />
      </Td>

      <Td w="33%">
        <CustomInput
          type="select"
          name={`${basePath}.isActive`}
          value={approvals[index]?.isActive || { label: "Yes", value: true }}
          placeholder="Active User"
          options={[
            { label: "Yes", value: true },
            { label: "No", value: false },
          ]}
          onChange={(e: any) => setFieldValue(`${basePath}.isActive`, e)}
          rest={{ width: "100%" }}
          disabled={isDisabled}
          isBoxSelect={true}
        />
      </Td>

      <Td display="none">
        <CustomInput
          type="select"
          name={`${basePath}.role`}
          value={approvals[index]?.role || roles[1]}
          options={roles}
          onChange={(e: any) => setFieldValue(`${basePath}.role`, e)}
          rest={{ width: "130px" }}
          disabled={isDisabled}
          isBoxSelect={true}
        />
      </Td>

      <Td display="none">
        <CustomInput
          type="select"
          name={`${basePath}.level`}
          value={approvals[index]?.level || ""}
          options={generateLevels?.(7) || []}
          onChange={(e: any) => setFieldValue(`${basePath}.level`, e)}
          rest={{ width: "130px" }}
          disabled={isDisabled}
          isBoxSelect={true}
        />
      </Td>


      {/* Permissions display: none */}
      {/* <Td display="none">...Permissions...</Td> */}

      <Td>
        <Flex gap={2}>
          <Tooltip label="Delete Approval" hasArrow placement="left">
            <IconButton
              aria-label="Delete"
              size="sm"
              variant={"outline"}
              colorScheme="red"
              icon={<DeleteIcon />}
              onClick={() => {
                if (setDeletedApproavals) {
                  if (approvals[index]?.user)
                    setDeletedApproavals((prev: any) => [
                      ...prev,
                      approvals[index],
                    ]);
                }
                remove(index);
              }}
            />
          </Tooltip>
        </Flex>
      </Td>
    </Tr>
  );
};

export default UserApprovalForeign;
